<template>
  <div>
    <div class="fade-carousel" />
    <el-carousel
      ref="slider"
      height="100vh"
      :interval="20000"
      arrow="never"
      indicator-position="none"
      @change="onChange"
    >
      <el-carousel-item>
        <first-frame />
      </el-carousel-item>
      <el-carousel-item>
        <second-frame />
      </el-carousel-item>
      <el-carousel-item v-for="(bids, i) in bidsChunks" :key="i">
        <third-frame
          :bids="bids"
          :freights-types="freightsTypeList"
          :bids-types="bidsTypeList"
        />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { toChunks } from '@/helpers/functions'
import FirstFrame from './components/FirstFrame'
import SecondFrame from './components/SecondFrame'
import ThirdFrame from './components/ThirdFrame'

export default {
  name: 'Infografic',
  components: {
    FirstFrame,
    SecondFrame,
    ThirdFrame,
  },
  computed: {
    ...mapGetters({ getBids: 'bids/getBids', getLibObj: 'libs/getLibObj' }),
    bidsChunks() {
      if (!this.getBids || !this.getBids.length) {
        return []
      }

      return toChunks(this.getBids, 2)
    },
    freightsTypeList() {
      return this.getLibObj('freightTypes')
    },
    bidsTypeList() {
      return this.getLibObj('loadTypes')
    },
  },
  created() {
    this.fetchPromoBids()
    this.$store.dispatch('libs/setLibs')
  },
  methods: {
    ...mapActions('bids', ['fetchPromoBids']),
    onChange(index) {
      if (!index) {
        this.fetchPromoBids()
      }
    },
  },
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Roboto&display=swap');
</style>
<style lang="sass">
.fade-carousel
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 999;
</style>
